import {VastType} from "../getSources";

export const setupEvents = (props: { vpaid: any, containerAd: HTMLDivElement, video: HTMLVideoElement, width: number, height: number, vast: VastType, complete: (hasError: string) => void, adLoad: () => void, adPause: (ret: (() => void) | undefined) => void, adStart: () => void, getVolume: () => number }) => {

    const {
        vpaid,
        complete,
        getVolume,
        adStart,
        width,
        height,
        containerAd,
        video,
        vast,
        adLoad,
        adPause
    } = props;

    if (vast === "NONE") {

        complete("setupEvent: emptyvast");
        return;
    }

    let addEventListener: (((name: string, func: any) => void) | false) = false;
    let removeEventListener: (((name: string, func: any) => void) | false) = false;

    if (vpaid.addEventListener) {
        addEventListener = (name, func) => vpaid.addEventListener(name, func);
    }
    else if (vpaid.subscribe) {
        addEventListener = (name, func) => vpaid.subscribe(func, name);
    }
    else if (vpaid.on) {
        addEventListener = (name, func) => vpaid.on(func, name);
    }

    if (vpaid.removeEventListener) {
        removeEventListener = (name, func) => vpaid.removeEventListener(name, func);
    }
    else if (vpaid.unsubscribe) {
        removeEventListener = (name, func) => vpaid.unsubscribe(func, name);
    }
    else if (vpaid.off) {
        removeEventListener = (name, func) => vpaid.off(func, name);
    }


    let removeEvents: {
        listener: (ev: any) => void,
        eventName: string
    }[] = [];
    let cekat: any = undefined;
    let interval = 0;
    let zacatekCalled = false;

    let ukonceniCalled = false;

    const ukonceni = (hasError: string) => {
        if (ukonceniCalled)
            return;

        ukonceniCalled = true;
        clearInterval(interval);
        removeEvents.forEach(m => {
            try {
                if (removeEventListener)
                    removeEventListener(m.eventName, m.listener);
            } catch (e) {

            }
        });
        complete(hasError);
    }

    const zacatek = () => {
        if (zacatekCalled)
            return;
        cekat = setTimeout(() => ukonceni("setupEvents: vpaid.AddError"), 10000);
    }
    let duration = 0;
    let timeupdate = false;
    ['AdStarted',
        'AdLoaded',
        'AdStopped',
        'AdSkipped',
        'AdLinearChange',
        'AdSizeChange',
        'AdExpandedChange',
        'AdImpression',
        'AdSkippableStateChange',
        'AdDurationChange',
        'AdRemainingTimeChange',
        'AdVolumeChange',
        'AdImpression',
        'AdClickThru',
        'AdInteraction',
        'AdVideoStart',
        'AdVideoFirstQuartile',
        'AdVideoMidpoint',
        'AdVideoThirdQuartile',
        'AdVideoComplete',
        'AdUserAcceptInvitation',
        'AdUserMinimize',
        'AdUserClose',
        'AdPaused',
        'AdPlaying',
        'AdError',
        'AdLog'].forEach(eventName => {
        const listener = (ev: any) => {
            switch (eventName) {
                case 'AdVolumeChange':
                    const v = getVolume();
                    if (v > 0) {
                        vast.tracker?.setMuted(false);
                    } else {
                        vast.tracker?.setMuted(true);
                    }
                    return;
                case 'AdRemainingTimeChange':
                case 'AdRemainingTime':
                    if (timeupdate)
                        return;
                    vast.tracker?.setProgress(duration - vpaid.getAdRemainingTime());
                    return;
                case 'AdVideoStart':
                    video.addEventListener('timeupdate', () => {
                        if (!duration) {
                            duration = video.duration;
                            vast.tracker?.setDuration(duration);
                        }
                        if (video.currentTime > 0)
                            timeupdate = true;
                        vast.tracker?.setProgress(video.currentTime);
                    });
                    vast.tracker?.setProgress(0);
                    return;
                case 'AdPaused':
                    adPause(() => {
                        vpaid.resumeAd();
                    });
                    return;
                case 'AdPlaying':
                    adPause(undefined);
                    return;
                case 'AdVideoFirstQuartile':
                    if (duration)
                        return;
                    vast.tracker?.setProgress(6);
                    return;
                case 'AdVideoMidpoint':
                    if (duration)
                        return;
                    vast.tracker?.setProgress(11);
                    return;
                case 'AdVideoThirdQuartile':
                    if (duration)
                        return;
                    vast.tracker?.setProgress(16);
                    return;
                case 'AdVideoComplete':
                    vast.tracker?.setProgress(20);
                    vast.tracker?.complete();
                    return;
                case 'AdClickThru':
                    vast.tracker?.click();
                    return;
                case 'AdSizeChange':
                    return;
                case 'AdLoaded':
                    vpaid.setAdVolume(getVolume());
                    vpaid.startAd();
                    adLoad();
                    return;
                case 'AdStarted':
                    let availDuration = vpaid.getAdDuration();
                    if (availDuration > 0) {
                        duration = availDuration
                        vast.tracker?.setDuration(duration);
                    } else {
                        availDuration = parseFloat(vpaid?.options?.duration);
                        if (availDuration > 0) {
                            duration = availDuration;
                            vast.tracker?.setDuration(duration);
                        } else {
                            vast.tracker?.setDuration(20);
                        }
                    }
                    vast.tracker?.trackImpression();

                    if (cekat)
                        clearTimeout(cekat);
                    adStart();
                    return;
                case 'AdError':
                    complete("setupEvents: vpaid.AddError");
                    return;
                case 'AdSkipped':
                    vast.tracker?.skip();
                    ukonceni("");
                    return;
                case 'AdStopped':
                    vast.tracker?.close();
                    ukonceni("");
                    return;
            }
        };

        try {
            addEventListener && addEventListener(eventName, listener);
            removeEvents.push({
                listener,
                eventName
            });
        } catch (e) {
            complete("setupEvent: addlisteners");
        }
    });

    zacatek();

    try {
        // @ts-ignore
        const AdParameters = vast.companion?.adParameters || {}
        try {
            vpaid.initAd(width, height, 'normal', 0, {AdParameters}, {
                videoSlotCanAutoPlay: true,
                slot: containerAd,
                videoSlot: video
            });
        } catch (e) {

            // @ts-ignore
            const AdParameters = vast.companion?.adParameters
            vpaid.initAd(width, height, 'normal', 0, AdParameters, {
                videoSlotCanAutoPlay: true,
                slot: containerAd,
                videoSlot: video
            });
        }
    } catch (e) {

        complete("setupEvent: vpaid.initAd");
    }


};
